import axios from 'axios';

import { datadogRum } from 'root/datadog/datadogRum';

export async function fetchAllEmployees(): Promise<LSEmployee[]> {
  try {
    const employees: LSEmployee[] = [];
    let next = `/API/V3/Account/${window.merchantos.account.id}/Employee.json?load_relations=all`;

    do {
      // eslint-disable-next-line no-await-in-loop
      const employeeRes = await axios.get<LSEmployeeData>(next);
      const employeeArr = Array.isArray(employeeRes.data.Employee)
        ? employeeRes.data.Employee
        : [employeeRes.data.Employee];

      employees.push(...employeeArr);
      next = employeeRes.data['@attributes'].next;
    } while (next);

    return employees;
  } catch (e) {
    datadogRum.addError(e, {
      message: 'LS_INVOICING_ERROR: Could not fetch employees.',
      accountId: window.merchantos.account.id,
    });
    return [];
  }
}
